import { Generic } from './Audio';
export function isAudio(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isAudio;    //# sourceMappingURL=isAudio.js.map
